import React from 'react'

function TenderTextSKS() {
  return (
    <embed src="\pdfs\EAT2.1.1.2_SKS-4-3-duo_Static_Cooling_Ceiling_System_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSKS